import axios from 'axios';
import { CatalogDetail } from './detail-catalog';

const apiUrl = process.env.BACKEND_ENDPOINT;

export interface CatalogRating {
  id?: string;
  value: number;
  catalogItem: CatalogDetail;
  createdAt: string;
  updatedAt: string;
}

export interface CatalogRatingResponse {
  id: string;
}

export interface CatalogRatingWithComment {
  value: number;
  comment?: string;
}

export async function getCatalogRatings(): Promise<CatalogRating[]> {
  const endpoint = `${apiUrl}/v1/catalog/ratings`;
  const response = await axios.get(endpoint);
  return response.data;
}

export async function getCatalogRating(
  ratingId: string
): Promise<CatalogRating> {
  const endpoint = `${apiUrl}/v1/catalog/ratings/${ratingId}`;
  const response = await axios.get(endpoint);
  return response.data;
}

export async function getCatalogRatingsByCatalogId(
  catalogId: string
): Promise<CatalogRating[]> {
  const endpoint = `${apiUrl}/v1/catalog/${catalogId}/ratings`;
  const response = await axios.get(endpoint);
  return response.data;
}

export async function postCatalogRating(
  catalogId: string,
  rating: CatalogRatingWithComment
): Promise<CatalogRatingResponse> {
  const endpoint = `${apiUrl}/v1/catalog/${catalogId}/ratings`;
  const response = await axios.post(endpoint, rating);
  return response.data;
}
